/*
 * Lane Linen — out-of-stock color swatches (size-aware).
 * Colors are separate products linked via the custom.product_for_color metafield.
 * Each color swatch <li data-ll-color> carries:
 *   data-ll-available="true|false"  — whether the color product has ANY available variant
 *   data-ll-sizes='{"Twin":true,"King":false,...}' — per-size availability for that color
 *   data-ll-variants='{"Twin":123,...}' — variant id per size for that color
 * When the shopper picks a size, colors unavailable in that size get struck (.ll-color-oos),
 * and each swatch link points at the same size in that color, so switching color keeps
 * the size (and its price) instead of falling back to Twin.
 * Fully sold-out colors are always struck. Sizes themselves are handled by the theme's
 * native variant picker (.disabled class) + CSS — no JS needed there.
 *
 * Note: the theme's product-info.js re-renders <variant-selects> innerHTML on every
 * variant change, replacing the size radios. So we (1) delegate the change listener on
 * document (survives the swap) and (2) re-apply whenever <variant-selects> re-renders.
 */
(function () {
  function selectedSize() {
    var checked = document.querySelector('.pro-input-Size input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function keepSize(li, size) {
    var a = li.querySelector('a[href]');
    if (!a) return;
    var ids = {};
    try { ids = JSON.parse(li.getAttribute('data-ll-variants') || '{}'); } catch (e) { ids = {}; }
    var base = a.getAttribute('href').split('?')[0];
    a.setAttribute('href', size && ids[size] ? base + '?variant=' + ids[size] : base);
  }

  function apply() {
    var colors = document.querySelectorAll('[data-ll-color]');
    if (!colors.length) return;
    var size = selectedSize();
    colors.forEach(function (li) {
      var out = li.getAttribute('data-ll-available') === 'false';
      if (!out && size) {
        var map = {};
        try { map = JSON.parse(li.getAttribute('data-ll-sizes') || '{}'); } catch (e) { map = {}; }
        if (Object.prototype.hasOwnProperty.call(map, size) && map[size] === false) {
          out = true;
        }
      }
      li.classList.toggle('ll-color-oos', out);
      keepSize(li, size);
    });
  }

  var timer = null;
  function scheduleApply() {
    // setTimeout (not rAF) so it still fires when the tab isn't foregrounded.
    if (timer) return;
    timer = setTimeout(function () { timer = null; apply(); }, 0);
  }

  // Delegated: catches clicks on size radios even after the picker is re-rendered.
  // Runs apply() synchronously so the swatches update on the click itself.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('.pro-input-Size input[type="radio"]')) {
      apply();
    }
  });

  // Belt-and-suspenders: re-apply after the theme re-renders <variant-selects>.
  function observe() {
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      new MutationObserver(scheduleApply).observe(vs, { childList: true, subtree: true });
    });
  }

  function boot() {
    observe();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
